import "./AudioControls.css";

export default function AudioControls({ volume, setVolume, isMuted, setIsMuted }) {
    return (
        <div className="audio-controls">
            <button 
                className="mute-button" 
                onClick={() => setIsMuted(!isMuted)}
                title={isMuted ? "Unmute" : "Mute"}
            >
                {(isMuted || volume === 0) ? "🔇" : "🔊"}
            </button>
            <input 
                type="range" 
                min="0" 
                max="1" 
                step="0.1" 
                value={volume} 
                onChange={(e) => setVolume(parseFloat(e.target.value))}
                className="volume-slider"
                title="Volume"
                disabled={isMuted}
            />
        </div>
    );
}
